var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{class:_vm.className,attrs:{"variant":_vm.variant}},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }